(function () {
  'use strict';

  function initPdp(section, attempts) {
    if (section.dataset.rielliPdpReady === 'true') return;

    var slider = section.querySelector('[data-product-single-media-slider]');
    var controls = section.querySelectorAll('[data-rielli-media-index]');
    if (!slider || !controls.length) return;

    var Flickity = window.themeVendor && window.themeVendor.Flickity;
    var gallery = Flickity && Flickity.data(slider);
    if (!gallery) {
      if (attempts < 40) window.setTimeout(function () { initPdp(section, attempts + 1); }, 100);
      return;
    }

    section.dataset.rielliPdpReady = 'true';

    function setActive(index) {
      controls.forEach(function (control) {
        var active = Number(control.dataset.rielliMediaIndex) === index;
        control.classList.toggle('is-active', active);
        control.setAttribute('aria-pressed', String(active));
      });
    }

    controls.forEach(function (control) {
      control.addEventListener('click', function () {
        gallery.select(Number(control.dataset.rielliMediaIndex));
      });
    });

    gallery.on('change', setActive);
    setActive(gallery.selectedIndex || 0);
  }

  function initAll(root) {
    root.querySelectorAll('.rielli-pdp').forEach(function (section) {
      initPdp(section, 0);
      initSizeLabels(section);
    });
    root.querySelectorAll('[data-rielli-complete-look]').forEach(initCompleteLook);
    root.querySelectorAll('[data-rielli-notification]').forEach(initInlineNotification);
    root.querySelectorAll('[data-rielli-sticky-atc]').forEach(initStickyAtc);
  }

  // Palo Alto writes raw option values to the popout after selection. Keep its
  // underlying value untouched and restore the corresponding display label.
  function initSizeLabels(section) {
    section.querySelectorAll('[data-rielli-size-display]').forEach(function (display) {
      if (display.dataset.rielliSizeReady === 'true') return;
      display.dataset.rielliSizeReady = 'true';
      var popout = display.closest('[data-popout]');
      var input = popout && popout.querySelector('[data-popout-input]');
      if (!input) return;
      function syncLabel() {
        var selected = Array.from(popout.querySelectorAll('[data-popout-option]')).find(function (option) {
          return option.dataset.value === input.value;
        });
        if (!selected) return;
        var label = selected.textContent.trim();
        if (display.textContent !== label) display.textContent = label;
      }
      new MutationObserver(syncLabel).observe(display, { childList: true, characterData: true, subtree: true });
      syncLabel();
    });
  }

  function initStickyAtc(sticky) {
    if (sticky.dataset.rielliStickyReady === 'true') return;

    var sourceButton = document.getElementById(sticky.dataset.sourceButton);
    var stickyButton = sticky.querySelector('[data-rielli-sticky-button]');
    var stickyLabel = sticky.querySelector('[data-rielli-sticky-label]');
    var stickyVariant = sticky.querySelector('[data-rielli-sticky-variant]');
    var stickySize = sticky.querySelector('[data-rielli-sticky-size]');
    var stickyPrice = sticky.querySelector('[data-rielli-sticky-price]');
    var productSection = sticky.previousElementSibling;
    var mobileViewport = window.matchMedia('(max-width: 767px)');
    if (!sourceButton || !stickyButton || !productSection) return;

    sticky.dataset.rielliStickyReady = 'true';

    function setVisibility() {
      var sourceRect = sourceButton.getBoundingClientRect();
      var visible = mobileViewport.matches && sourceRect.bottom < 0;
      sticky.classList.toggle('is-visible', visible);
      sticky.setAttribute('aria-hidden', String(!visible));
      stickyButton.setAttribute('tabindex', visible ? '0' : '-1');
    }

    function syncButton() {
      var sourceLabel = sourceButton.querySelector('[data-add-to-cart-text]');
      var loading = sourceButton.classList.contains('is-loading');
      if (sourceLabel) stickyLabel.textContent = sourceLabel.textContent.trim();
      stickyButton.disabled = sourceButton.disabled || loading;
      stickyButton.classList.toggle('is-loading', loading);
      stickyButton.setAttribute('aria-busy', String(loading));
    }

    function syncSizeFromProduct() {
      if (!stickySize) return;
      var optionName = 'options[' + stickySize.dataset.optionName + ']';

      productSection.querySelectorAll('[data-single-option-selector]').forEach(function (option) {
        if (option.name !== optionName) return;
        if (option.type !== 'radio' || option.checked) stickySize.value = option.value;
      });
    }

    function syncVariant(variant) {
      window.requestAnimationFrame(function () {
        if (variant && stickyVariant) stickyVariant.textContent = variant.title;
        if (variant && stickySize) {
          stickySize.value = variant.options[Number(stickySize.dataset.optionIndex)];
        } else {
          syncSizeFromProduct();
        }
        var productPrice = productSection.querySelector('[data-product-price]');
        if (productPrice && stickyPrice) stickyPrice.textContent = productPrice.textContent.trim();
        syncButton();
      });
    }

    if (stickySize) {
      stickySize.addEventListener('change', function () {
        var optionName = 'options[' + stickySize.dataset.optionName + ']';
        var matchingOption = null;

        productSection.querySelectorAll('[data-single-option-selector]').forEach(function (option) {
          if (option.name !== optionName) return;
          if (option.type === 'radio' && option.value === stickySize.value) matchingOption = option;
          if (option.type !== 'radio' && !matchingOption) matchingOption = option;
        });

        if (!matchingOption || matchingOption.disabled) {
          syncSizeFromProduct();
          return;
        }

        if (matchingOption.type === 'radio') {
          matchingOption.click();
        } else {
          matchingOption.value = stickySize.value;
          var popout = matchingOption.closest('[data-popout]');
          var popoutText = popout && popout.querySelector('[data-popout-text]');
          if (popoutText) popoutText.textContent = stickySize.value;
          matchingOption.dispatchEvent(new Event('change', {bubbles: true}));
        }
      });
    }

    stickyButton.addEventListener('click', function () {
      var isNotification = sourceButton.hasAttribute('data-rielli-notify-trigger') &&
        sourceButton.closest('[data-form-wrapper]') &&
        sourceButton.closest('[data-form-wrapper]').classList.contains('variant--soldout');
      sourceButton.click();
      if (isNotification) sourceButton.scrollIntoView({behavior: 'smooth', block: 'center'});
    });

    new MutationObserver(syncButton).observe(sourceButton, {
      attributes: true,
      attributeFilter: ['class', 'disabled'],
      childList: true,
      characterData: true,
      subtree: true
    });

    productSection.addEventListener('theme:variant:change', function (event) {
      syncVariant(event.detail && event.detail.variant);
    });

    document.addEventListener('scroll', setVisibility, {passive: true});
    window.addEventListener('resize', setVisibility, {passive: true});
    syncButton();
    setVisibility();
  }

  function initInlineNotification(notification) {
    if (notification.dataset.rielliNotificationReady === 'true') return;

    var wrapper = notification.closest('[data-form-wrapper]');
    var trigger = wrapper && wrapper.querySelector('[data-rielli-notify-trigger]');
    var input = notification.querySelector('[data-rielli-notification-input]');
    if (!wrapper || !trigger) return;

    notification.dataset.rielliNotificationReady = 'true';

    function setOpen(open, focusInput) {
      notification.classList.toggle('is-open', open);
      notification.setAttribute('aria-hidden', String(!open));
      trigger.setAttribute('aria-expanded', String(open));
      if (open && focusInput && input) {
        var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        window.setTimeout(function () { input.focus(); }, reduceMotion ? 0 : 360);
      }
    }

    trigger.addEventListener('click', function (event) {
      if (!wrapper.classList.contains('variant--soldout')) return;
      event.preventDefault();
      event.stopPropagation();
      setOpen(!notification.classList.contains('is-open'), true);
    });

    if (notification.querySelector('.rielli-notification__success, .rielli-notification__errors')) {
      setOpen(true, false);
    }

    wrapper.addEventListener('rielli:notification:close', function () {
      setOpen(false, false);
    });
  }

  function initCompleteLook(widget) {
    if (widget.dataset.rielliLookReady === 'true') return;
    widget.dataset.rielliLookReady = 'true';

    widget.addEventListener('change', function (event) {
      if (!event.target.matches('.rielli-complete-look__select')) return;
      var selected = event.target.selectedOptions[0];
      var price = event.target.closest('.rielli-complete-look__details').querySelector('[data-look-price]');
      if (selected && price) price.textContent = selected.dataset.price || '';
    });

    if (widget.dataset.automatic !== 'true') return;

    var routeRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var recommendationsUrl = (window.theme && window.theme.routes && window.theme.routes.product_recommendations_url) ||
      routeRoot + 'recommendations/products';

    async function loadIntent(intent) {
      var url = new URL(recommendationsUrl, window.location.origin);
      url.searchParams.set('section_id', widget.dataset.sectionId);
      url.searchParams.set('product_id', widget.dataset.productId);
      url.searchParams.set('limit', '10');
      url.searchParams.set('intent', intent);

      var response = await fetch(url.toString(), { credentials: 'same-origin' });
      if (!response.ok) return false;

      var html = new DOMParser().parseFromString(await response.text(), 'text/html');
      var result = html.querySelector('[data-rielli-complete-look]');
      var incomingItems = result && result.querySelector('[data-rielli-complete-look-items]');
      if (!result || Number(result.dataset.recommendationCount) < 1 || !incomingItems ||
          !incomingItems.querySelector('.rielli-complete-look__item')) return false;

      var currentItems = widget.querySelector('[data-rielli-complete-look-items]');
      if (currentItems && widget.isConnected) {
        currentItems.replaceChildren(...incomingItems.children);
        widget.hidden = false;
      }
      return true;
    }

    (async function () {
      try {
        if (await loadIntent('complementary')) return;
        await loadIntent('related');
      } catch (error) {
        // Keep the catalog fallback already rendered by Liquid.
      }
    }());
  }

  document.addEventListener('theme:variant:change', function (event) {
    var variant = event.detail && event.detail.variant;
    event.target.querySelectorAll('[data-rielli-notify-trigger]').forEach(function (trigger) {
      trigger.setAttribute('type', variant && variant.available ? 'submit' : 'button');
    });

    event.target.querySelectorAll('[data-rielli-stock]').forEach(function (stock) {
      var available = Boolean(variant && variant.available);
      var text = stock.querySelector('[data-rielli-stock-text]');
      stock.classList.toggle('is-sold-out', !available);
      if (text) text.textContent = available ? stock.dataset.inStockText : stock.dataset.soldOutText;
    });

    if (variant && variant.available) {
      event.target.querySelectorAll('[data-form-wrapper]').forEach(function (wrapper) {
        wrapper.dispatchEvent(new CustomEvent('rielli:notification:close'));
      });
    }
  });

  // The theme relabels the Add to Cart button as "Sold Out - Notify Me When It's Available"
  // when a sold-out variant is picked. Swap that for the shorter Rielli label.
  function shortenNotifyButtons(root) {
    root.querySelectorAll('[data-rielli-notify-text]').forEach(function (button) {
      var label = button.querySelector('[data-add-to-cart-text]');
      if (!label || label.dataset.rielliNotifyWatched) return;
      label.dataset.rielliNotifyWatched = 'true';

      var soldOutPrefix = window.theme && theme.strings && theme.strings.sold_out ? theme.strings.sold_out + ' - ' : null;
      var shorten = function () {
        var wrapper = button.closest('[data-form-wrapper]');
        var isSoldOut = wrapper && wrapper.classList.contains('variant--soldout');
        var hasLongLabel = soldOutPrefix && label.textContent.trim().indexOf(soldOutPrefix) === 0;
        if ((isSoldOut || hasLongLabel) && label.textContent.trim() !== button.dataset.rielliNotifyText) {
          label.textContent = button.dataset.rielliNotifyText;
        }
      };

      new MutationObserver(shorten).observe(label, {childList: true, characterData: true, subtree: true});
      shorten();
    });
  }

  document.addEventListener('DOMContentLoaded', function () { shortenNotifyButtons(document); });
  if (document.readyState !== 'loading') shortenNotifyButtons(document);
  document.addEventListener('shopify:section:load', function (event) { shortenNotifyButtons(event.target); });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
}());
